<template>
  <svg
    id="Reservados"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height ? height : width"
    viewBox="0 0 236.952 202.386"
  >
    <g
      id="Retângulo_19"
      data-name="Retângulo 19"
      transform="translate(0 26.386)"
      fill="none"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="15"
    >
      <rect width="182" height="176" rx="35" stroke="none" />
      <rect x="7.5" y="7.5" width="167" height="161" rx="27.5" fill="none" />
    </g>
    <rect
      id="Retângulo_20"
      data-name="Retângulo 20"
      width="108"
      height="155"
      transform="translate(87 23.386)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-file"
      data-name="Icon awesome-file"
      d="M72.479,43.848V0H7.766A7.733,7.733,0,0,0,0,7.738v149.6a7.733,7.733,0,0,0,7.766,7.738H116.485a7.733,7.733,0,0,0,7.766-7.738V51.586H80.245A7.775,7.775,0,0,1,72.479,43.848ZM124.25,39.3v1.967H82.834V0h1.974a7.774,7.774,0,0,1,5.5,2.257l31.677,31.6A7.7,7.7,0,0,1,124.25,39.3Z"
      transform="translate(100.168)"
      :fill="color"
    />
    <rect
      id="Retângulo_21"
      data-name="Retângulo 21"
      width="126"
      height="165"
      rx="3"
      transform="translate(107 4.386)"
      fill="#fff"
    />
    <path
      id="Icon_awesome-file-2"
      data-name="Icon awesome-file"
      d="M72.479,43.848V0H7.766A7.733,7.733,0,0,0,0,7.738v149.6a7.733,7.733,0,0,0,7.766,7.738H116.485a7.733,7.733,0,0,0,7.766-7.738V51.586H80.245A7.775,7.775,0,0,1,72.479,43.848ZM124.25,39.3v1.967H82.834V0h1.974a7.774,7.774,0,0,1,5.5,2.257l31.677,31.6A7.7,7.7,0,0,1,124.25,39.3Z"
      transform="translate(112.701 7.311)"
      :fill="color"
    />
    <path
      id="Icon_awesome-lock"
      data-name="Icon awesome-lock"
      d="M28.125,15.75H26.438V10.688a10.688,10.688,0,0,0-21.375,0V15.75H3.375A3.376,3.376,0,0,0,0,19.125v13.5A3.376,3.376,0,0,0,3.375,36h24.75A3.376,3.376,0,0,0,31.5,32.625v-13.5A3.376,3.376,0,0,0,28.125,15.75Zm-7.312,0H10.688V10.688a5.063,5.063,0,0,1,10.125,0Z"
      transform="translate(159 71.386)"
      fill="#fff"
    />
    <rect
      id="Retângulo_22"
      data-name="Retângulo 22"
      width="15"
      height="5"
      rx="2.5"
      transform="translate(123 115.386)"
      fill="#fff"
    />
    <rect
      id="Retângulo_26"
      data-name="Retângulo 26"
      width="43"
      height="5"
      rx="2.5"
      transform="translate(147 115.386)"
      fill="#fff"
    />
    <rect
      id="Retângulo_27"
      data-name="Retângulo 27"
      width="28"
      height="5"
      rx="2.5"
      transform="translate(199 115.386)"
      fill="#fff"
    />
    <path
      id="Caminho_2"
      data-name="Caminho 2"
      d="M.624.167,8.737,2.343a1.42,1.42,0,0,1,.791,1.093c.092.511-.112.851-.457.758L.959,2.018A1.42,1.42,0,0,1,.167.925C.075.414.279.075.624.167Z"
      transform="translate(138.449 121.604) rotate(-66)"
      fill="#fff"
    />
    <path
      id="Caminho_3"
      data-name="Caminho 3"
      d="M.624.167,8.737,2.343a1.42,1.42,0,0,1,.791,1.093c.092.511-.112.851-.457.758L.959,2.018A1.42,1.42,0,0,1,.167.925C.075.414.279.075.624.167Z"
      transform="translate(190.449 121.604) rotate(-66)"
      fill="#fff"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { required: false, type: String, default: '100%' },
    height: { required: false, type: String },
    color: { required: false, type: String, default: '#4e73df' }
  }
}
</script>
